import { FC } from 'react'
import { Checkbox, CheckboxProps } from '@mui/material'

export const EvtCheckbox: FC<CheckboxProps> = ({ ...props }) => {
    return <Checkbox {...props} />
}
